/**
 * Hardcoded radio id redirects for physically printed QR codes whose radio was
 * replaced. The encoded redeem code embeds an old radioid (e.g. `code-2124`);
 * when that radio no longer exists, `singlecola` returns "Radio does not exist".
 *
 * To keep the printed QRs working we remap the old radioid to the new one right
 * before resolving the radio. To add or remove an adjustment, just edit the map:
 * the key is the OLD radioid baked into the QR, the value is the CURRENT radioid.
 *
 * Keys and values are kept as strings because radioids flow through the app as
 * strings (decrypted from `code-radioid`).
 */
export const RADIO_ID_REDIRECTS = {
  // El eskondite  (redeem nIo9yxJwSWFtHc17jp1enw)
  "2124": "2136",
  // Estudio 21    (redeem 7nlB_ImA2hmHmSV2QZCqgQ)
  "2123": "2135",
  // KFC Ventura Terreros -> Mercurio Soacha https://millsonicbox.com/redeem/ZKLULi_T6FkbdeNuzBJrRA
  "2209": "2221",
};

/**
 * Returns the current radioid for a (possibly outdated) radioid, applying any
 * configured redirect. Returns the input unchanged when there is no redirect.
 * @param {string|number} radioid
 * @returns {string|number} the redirected radioid, or the original
 */
export const resolveRedirectedRadioid = (radioid) => {
  if (radioid === null || radioid === undefined) return radioid;
  const key = String(radioid);
  return RADIO_ID_REDIRECTS[key] ?? radioid;
};
